<template>
    <div>
        <v-server-table ref="SafetySettingsTable" url="/admin/safety-settings-list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-2 ml-sm-0 mt-2 mt-sm-0">
                <router-link class="btn btn-outline-success" :to="`/jsa/settings/create`">
                    <i class="fa fa-plus"></i> Add Setting
                </router-link>
            </div>

            <router-link slot="safety_hazard_id" slot-scope="props" :to="`/jsa/settings/edit/${props.row.safety_hazard_id}`" title="Edit JSA Control" class="btn btn-sm btn-default">
                <i class="fa fa-edit"></i>
            </router-link>

            <template slot="controls" slot-scope="props">
                {{ props.row.controls.map(e => e.control_name).join(', ') }}
            </template>

            <template slot="is_active" slot-scope="props">
                <label :class="`badge badge-${props.row.is_active == 1 ? 'success' : 'warning'}`">
                    {{ props.row.is_active == 1 ? 'Active' : 'Inactive' }}
                </label>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['safety_hazard_id', 'hazard_name', 'controls', 'is_active'],
                options: {
                    columnsDropdown: false,
                    headings: {
                        safety_hazard_id: 'Actions',
                        hazard_name: 'Hazard',
                        controls: 'Controls',
                        is_active: 'Is Active'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'safety_hazards.hazard_name',
                    },
                    uniqueKey: 'safety_hazard_id',
                },
            }
        }
    }
</script>
